import React from 'react';

// Hooks
import useUrlContains from '@arctheme-hooks/useUrlContains';

type Props = {
  children: React.ReactNode;
  link: string;
  classes?: string;
  ariaLabel?: string;
  openInNewTab?: boolean;
  role?: string;
  onClick?: (event: any) => void;
  onMouseOver?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  onMouseDown?: () => void;
};

export const Link = ({
  children,
  link,
  classes = '',
  ariaLabel,
  openInNewTab,
  role,
  onClick,
  onMouseOver,
  onMouseEnter,
  onMouseLeave,
  onMouseDown
}: Props) => {
  // Hooks
  const isActive = useUrlContains(link);

  return (
    <>
      {link ? (
        <a
          href={link}
          className={`${classes} ${isActive ? 'link--active' : ''}`}
          aria-label={ariaLabel}
          onClick={onClick}
          onMouseOver={onMouseOver}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          onMouseDown={onMouseDown}
          target={openInNewTab ? '_blank' : ''}
          role={role}
        >
          {children}
        </a>
      ) : (
        <>{children}</>
      )}
    </>
  );
};

